export default function activeAudioReducer(state = null, action) {
  switch (action.type) {
    case 'SET_ACTIVE_AUDIO':
      return action.payload
    default:
      return state
  }
}
